import { AxiosInstance } from 'axios';
import { http as httpInstance } from './config';
import {
  ApiAuth,
  ApiBlock,
  ApiExceptionWordConfiguration,
  ApiHistory,
  ApiImport,
  ApiImportData,
  ApiLogin,
  ApiLogout,
  ApiOrganization,
  ApiRestorePassword,
  ApiRole,
  ApiSearch,
  ApiSearchTree,
  ApiSendEmail,
  ApiStaff,
  ApiSubdivision,
  ApiThank,
  ApiUpdateIsKarmaUser,
  ApiUpdateStatusUser,
  ApiUpdateUser,
  Apiuser,
  ApiValue,
  Download,
  Limit,
  MaxLimit,
  Received,
  Sent,
} from './entity';
import { Analytics } from './entity/analytics';
import { ApiUpdateConfiguration } from './entity/configuration';
import { AnalyticsTree } from './entity/analyticsTree';

interface ApiServiceInterface {
  [key: string]: any;
}

class ApiService implements ApiServiceInterface {
  logout: ApiLogout;

  user: Apiuser;

  login: ApiLogin;

  subdivisionParent: ApiSubdivision;

  subdivision: ApiSubdivision;

  block: ApiBlock;

  role: ApiRole;

  import: ApiImport;

  importData: ApiImportData;

  userUpdate: ApiUpdateUser;

  staff: ApiStaff;

  search: ApiSearch;

  searchTree: ApiSearchTree;

  organization: ApiOrganization;

  history: ApiHistory;

  isKarmaUserUpdate: ApiUpdateIsKarmaUser;

  sendEmail: ApiSendEmail;

  restorePassword: ApiRestorePassword;

  auth: ApiAuth;

  thank: ApiThank;

  value: ApiValue;

  download: Download;

  limit: Limit;

  maxLimit: MaxLimit;

  received: Received;

  sent: Sent;

  analytics: Analytics;

  analyticsTree: AnalyticsTree;

  status: ApiUpdateStatusUser;

  configuration: ApiUpdateConfiguration;

  word: ApiExceptionWordConfiguration;

  constructor(http: AxiosInstance) {
    this.logout = new ApiLogout(http, 'logout');
    this.user = new Apiuser(http, 'users');
    this.login = new ApiLogin(http, 'login/send-code');
    this.subdivisionParent = new ApiLogin(http, 'subdivisions/parent');
    this.subdivision = new ApiSubdivision(http, 'subdivisions');
    this.block = new ApiBlock(http, 'users');
    this.role = new ApiRole(http, 'users/roles/available');
    this.userUpdate = new ApiUpdateUser(http, 'users');
    this.import = new ApiImport(http, 'xml/import/from-external-service');
    this.importData = new ApiImportData(http, 'importData');
    this.staff = new ApiStaff(http, 'staffs');
    this.search = new ApiSearch(http, 'search');
    this.searchTree = new ApiSearchTree(http, 'search');
    this.organization = new ApiOrganization(http, 'organizations');
    this.history = new ApiHistory(http, 'history');
    this.isKarmaUserUpdate = new ApiUpdateUser(http, 'change/isKarma');
    this.sendEmail = new ApiSendEmail(http, 'restore/password/send-email');
    this.restorePassword = new ApiRestorePassword(http, 'restore/password');
    this.auth = new ApiAuth(http, 'login/code');
    this.thank = new ApiThank(http, 'thanks');
    this.value = new ApiValue(http, 'thanks/value');
    this.download = new ApiValue(http, 'thanks/download');
    this.limit = new ApiValue(http, 'thanks/personalLimit');
    this.maxLimit = new ApiValue(http, 'thanks/limit');
    this.received = new ApiValue(http, 'thanks/received');
    this.sent = new ApiValue(http, 'thanks/sent');
    this.analytics = new ApiValue(http, 'analytics');
    this.analyticsTree = new ApiValue(http, 'analytics');
    this.status = new ApiUpdateStatusUser(http, 'staff');
    this.configuration = new ApiUpdateConfiguration(http, 'configuration');
    this.word = new ApiExceptionWordConfiguration(http, 'word');
  }
}

export const api = new ApiService(httpInstance);
